import Link from 'next/link'
import { cn } from '@cerifi/ui/utils/cn'

import styles from './announcement-banner.module.css'

const AnnouncementBanner = ({ className }: { className?: string }) => {
  return (
    <div
      className={cn(
        'sticky w-full z-[1000] top-0 px-8 py-2 text-center text-sm bg-red-500',
        className,
        styles.announcementBanner
      )}
    >
      <p className="text-white capitalize">
        Free Webinar: What’s inside the One Big Beautiful Bill Act. {' '}
        <Link href="https://spidell.com/shop/webinars/key-points-of-obbba-odw/" target='_blank'>
          Explore More &#8594;
        </Link>
      </p>
    </div>
  )
}

export default AnnouncementBanner
